import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { IntegrationTokenBaseEffect } from './integration-token-base.effect';

@NgModule({
  imports: [ EffectsModule.forFeature([ IntegrationTokenBaseEffect ]) ]
})
export class IntegrationTokenBaseModule {}
